// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"disclaimer_backgroundColor___WAON","textClassName":"disclaimer_textClassName__PM8Pf","iconClassName":"disclaimer_iconClassName__0THQW"};